<div class="auth-container p-2">
  <div class="login-box">
  <div class="surface-card p-4 shadow-2 border-round-2xl w-full">

    <div class="text-center mb-5 mt-4">
      <img src="../../../../assets/images/logo_klaus_light_blue.svg" class="w-10rem" alt="logo">
    </div>

    <div class="text-center mb-4">
      <div class="text-color text-3xl font-semibold mb-2">Anmelden</div>
      <span class="text-600 font-medium line-height-3 text-color-secondary">Bitte melde dich mit deinen Benutzerdaten an.</span>
    </div>

    <div class="text-center mb-4 text-sm bg-blue-100 px-4 py-3 border-round">
      <span class="font-medium line-height-3 text-blue-500">Falls du bereits Kunde bist und die alte Klaus-Anwendung genutzt hast, kannst du dir über die Funktion "Passwort vergessen" ein neues Passwort für diese WebApp erstellen.</span>
    </div>

    <form (ngSubmit)="handleLogin()" >

    <div class="mb-4">
      <label for="email1" class="block text-900 font-medium mb-2">Email</label>
      <input name="email" id="email1" [(ngModel)]="email" type="text" placeholder="Email eingeben" pInputText class="w-full">
    </div>

    <div class="mb-4">
      <label for="password" class="block text-900 font-medium mb-2">Passwort</label>
      <p-password name="password" id="password" [(ngModel)]="password" placeholder="Passwort eingeben" styleClass="w-full" inputStyleClass="w-full"
                  [toggleMask]="true" [feedback]="false"></p-password>
    </div>

    <div class="text-right my-4">
      <a class="font-medium text-primary cursor-pointer" (click)="navigateToForgetPassword()">Passwort vergessen?</a>
    </div>

<!--    <button type="submit" pButton pRipple label="Anmelden" class="w-full" [disabled]="busy" (click)="handleLogin()"></button>-->

      <app-button [busy]="busy"
                  [disabled]="busy"
                  [type]="'submit'"
                  [label]="'Anmelden'"
                  [class]="'w-full'"
                  [showIcon]="false"
                  (onClick)="handleLogin()">
      </app-button>

      <app-button class="mt-3 block"
                  [busy]="busy"
                  [disabled]="busy"
                  [type]="'submit'"
                  [label]="'Login mit Einmalpasswort'"
                  [class]="'w-full bg-primary-50 text-primary border-0'"
                  [showIcon]="false"
                  (click)="navigateToLoginOtpCode()">
      </app-button>

    </form>

    <div class="flex flex-column mt-4 gap-2 text-center">
      <span class="text-color-secondary"> Du hast keinen Account?</span>
      <span class="text-primary font-medium cursor-pointer" (click)="navigateToRegistration()">Registrieren</span>
    </div>

  </div>
  </div>

</div>







